import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { applyPreset, art } from "../state/params.svelte";
import { PRESETS } from "../state/presets";

var root = $.from_html(`<button> </button>`);
var root_1 = $.from_html(`<div class="chips svelte-1l8j20awg17cr" role="group" aria-label="Presets"></div>`);

export default function PresetPicker($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root_1();

	$.each(div, 5, () => PRESETS, (p) => p.id, ($$anchor, p) => {
		var button = root();
		let classes;
		var text = $.child(button, true);

		$.reset(button);

		$.template_effect(() => {
			classes = $.set_class(button, 1, 'chip svelte-1l8j20awg17cr', null, classes, { active: art.presetId === $.get(p).id });
			$.set_attribute(button, 'aria-pressed', art.presetId === $.get(p).id);
			$.set_text(text, $.get(p).name);
		});

		$.delegated('click', button, () => applyPreset($.get(p)));
		$.append($$anchor, button);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:PresetPicker.svelte-r0cdvhx5eg5g-style.css";